<template>
  <div class="col-12" style="padding: 0;">
    <div class="row">
      <div class="col-12 mb-5 mt-5" style="text-align: center;">
        <h2>Top locations</h2>
      </div>
      <div class="col-6 col-md-3" style="height: 100px;text-align: center;margin: 0 0 30px 0;">
        <img style="width: 35%;border-radius: 5px;" alt="United States" src="https://cdn.proxyscrape.com/img/flags/svg/us.svg">
        <p style="    font-weight: 600;
    margin: 10px 0;">United States</p>
      </div>
      <div class="col-6 col-md-3" style="height: 100px;text-align: center;margin: 0 0 30px 0;">
        <img style="width: 35%;border-radius: 5px;" alt="United Kingdom" src="https://cdn.proxyscrape.com/img/flags/svg/gb.svg">
        <p style="    font-weight: 600;
    margin: 10px 0;">United Kingdom</p>
      </div>
      <div class="col-6 col-md-3" style="height: 100px;text-align: center;margin: 0 0 30px 0;"><img style="width: 35%;border-radius: 5px;" alt="Germany" src="https://cdn.proxyscrape.com/img/flags/svg/de.svg">
        <p style="    font-weight: 600;
    margin: 10px 0;">Germany</p></div>
      <div class="col-6 col-md-3" style="height: 100px;text-align: center;margin: 0 0 30px 0;"><img style="width: 35%;border-radius: 5px;" alt="France" src="https://cdn.proxyscrape.com/img/flags/svg/fr.svg">
        <p style="    font-weight: 600;
    margin: 10px 0;">France</p></div>
      <div class="col-6 col-md-3" style="height: 100px;text-align: center;margin: 0 0 30px 0;"><img style="width: 35%;border-radius: 5px;" alt="Russia" src="https://cdn.proxyscrape.com/img/flags/svg/ru.svg">
        <p style="    font-weight: 600;
    margin: 10px 0;">Russia</p></div>
      <div class="col-6 col-md-3" style="height: 100px;text-align: center;margin: 0 0 30px 0;"><img style="width: 35%;border-radius: 5px;" alt="Canada" src="https://cdn.proxyscrape.com/img/flags/svg/ca.svg">
        <p style="    font-weight: 600;
    margin: 10px 0;">Canada</p></div>
      <div class="col-6 col-md-3" style="height: 100px;text-align: center;margin: 0 0 30px 0;"><img style="width: 35%;border-radius: 5px;" alt="Brazil" src="https://cdn.proxyscrape.com/img/flags/svg/br.svg">
        <p style="    font-weight: 600;
    margin: 10px 0;">Brazil</p></div>
      <div class="col-6 col-md-3" style="height: 100px;text-align: center;margin: 0 0 30px 0;"><img style="width: 35%;border-radius: 5px;" alt="India" src="https://cdn.proxyscrape.com/img/flags/svg/in.svg">
        <p style="    font-weight: 600;
    margin: 10px 0;">India</p></div>

    </div>
  </div>
</template>

<script setup lang='ts'>
</script>

<style scoped>

</style>
